import { styled } from '@mui/material/styles'
import { PlaceOrderTitle } from 'components/PlaceOrderTitle'
import { memo, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { updateCreateOrderOption } from 'store/spot/actions'
import { useCurrentSpotSymbol } from 'store/spot/hooks'
import { Flex, Space12, Space16, Space24, Space4, Space8 } from 'styles'
import { SectionWrap } from 'styles/Link'
import { AmountPercent } from './AmountPercent'
import { ConnectOrOrderButton } from './ConnectOrOrderButton'
import { DirectionTabs } from './DirectionTabs'
import { DualModeAmountInput } from './DualModeAmountInput'
import { OrderModeSelection } from './OrderModeSelection'
import { PriceInput } from './PriceInput'
import { TotalAndFee } from './TotalAndFee'
import { OrderProperties } from './OrderProperties'

const CreateOrderBody = styled('div')`
  min-height: 740px;
  padding: 0 12px 12px;
  ${(props) => props.theme.breakpoints.down('md')} {
    min-height: auto;
    padding: 0 16px 16px;
  }
`
const TabOrSelectOrder = styled(Flex)`
  width: 100%;
  flex-direction: column;
  /* ${(props) => props.theme.breakpoints.down('md')} {
    flex-direction: row;
    justify-content: space-between;
  } */
`
const CreateOrderWrap = styled(SectionWrap)`
  height: 100%;
  ${(props) => props.theme.breakpoints.down('md')} {
    border-top: unset;
    border-bottom: unset;
  }
`

export const CreateOrderComponent = memo(() => {
  const dispatch = useDispatch()
  const { id = 0 } = useCurrentSpotSymbol()

  useEffect(() => {
    dispatch(updateCreateOrderOption({ option: 'limitPrice', value: '' }))
    dispatch(
      updateCreateOrderOption({ option: 'baseCurrencyAmount', value: '' }),
    )
    dispatch(
      updateCreateOrderOption({ option: 'quoteCurrencyAmount', value: '' }),
    )
  }, [dispatch, id])

  return (
    <CreateOrderWrap>
      <CreateOrderBody>
        <PlaceOrderTitle />
        <TabOrSelectOrder>
          <DirectionTabs />
          <OrderModeSelection />
        </TabOrSelectOrder>
        <Space4 />

        <PriceInput />

        <Space8 />
        <DualModeAmountInput />

        <Space12 />
        <AmountPercent />
        <Space12 />
        <TotalAndFee />
        <Space24 />

        <OrderProperties />

        <Space16 />
        <Flex id="zk_connect_order_button">
          <ConnectOrOrderButton />
        </Flex>
      </CreateOrderBody>
    </CreateOrderWrap>
  )
})
